import { createFileRoute } from "@tanstack/react-router";
import AdminCriterionTopicNewPage from "@/pages/admin/criterion-topics/new";
import { useCriterionTopicsContext } from "@/pages/admin/criterion-topics";

export const Route = createFileRoute("/app/admin/criterion-topics/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllCriteria, userCanViewAllCriteria, addNewTopic } = useCriterionTopicsContext();

  return (
    <AdminCriterionTopicNewPage
      userCanEditAllCriteria={userCanEditAllCriteria}
      userCanViewAllCriteria={userCanViewAllCriteria}
      addNewTopic={addNewTopic}
    />
  );
}
